// Shared modal appearance passed to the fullpage-modal component.
export const MODAL_STYLE = {
    backgroundColor: '#000',

    contentStyles: {
        borderRadius: '10px 10px 0px 0px',
        borderTop: '3px solid #333',
    },
};

// Frame of the bottom sheets; the group sheets keep MODAL_STYLE.
export const SHEET_STYLE = {
    backgroundColor: '#000',

    // pinned to the visible screen: in the iOS home-screen app the library's 100vh frame runs past it
    modalStyles: {
        position: 'fixed',
        top: 0,
        bottom: 0,
        minHeight: 0,
        overflowY: 'auto',
    },

    contentStyles: {
        borderRadius: '16px 16px 0 0',
        borderTop: '1px solid #2a2a2a',
    },
};

// A swipe down closes a sheet past this distance (px), or on a flick faster than this (px per ms).
export const SHEET_DISMISS_DISTANCE = 100;
export const SHEET_DISMISS_SPEED = 0.5;

// Chart series colors.
export const CHART_COLOR_BUY = '#eb6534';
export const CHART_COLOR_SELL = '#72cba0';
export const CHART_COLOR_LARGE_BUY = '#CC4514';
export const CHART_COLOR_PRICE_LINE = '#141414';

// Bubble radius for a single-position event; mirrors radius_base_circle in warren-api,
// which scales it by the square root of the position count.
export const CHART_BUBBLE_BASE_RADIUS = 3;

// Events packed into a narrower span than this read as one cluster, not a chart.
export const CHART_MIN_EVENT_SPAN_DAYS = 3;
